import bgBody from "assets/img/background-body-admin.jpg";

export const bgAdmin = {
  styles: {
    global: (props) => ({
      body: {
        bgImage: "https://plainbackground.com/plain1024/6a6a48.png",
        bgSize: "cover",
        bgPosition: "center center",
        
        
      },
    }),
  },
};
// https://5.imimg.com/data5/SELLER/Default/2024/2/382657962/VX/FB/LP/186421431/3mm-white-marble-veneer-500x500.png